import React, { Fragment } from "react";
import HeaderButton from "./HeaderButton.js";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

const ComponentButtons = (props) => {
    return (
        <Fragment>
            <div className="ml-10 mt-8">
                <HeaderButton 
                    title={"Add " + props.entity}
                    icon={icon({name: "plus", style: "regular"})}
                    type="primary"
                    disabled={!props.headerOptions.componentSelected}
                    onClick={() => props.addComponent()}
                />            
                <HeaderButton 
                    title={"Merge " + props.entity + "s"}
                    icon={icon({name: "layer-group", style: "light"})}
                    disabled={!props.headerOptions.nonTopComponentSelected}
                    onClick={() => props.mergeComponent()}
                />
                <HeaderButton 
                    title={"Remove " + props.entity}
                    icon={icon({name: "trash-can", style: "light"})}
                    disabled={!props.headerOptions.nonTopComponentSelected}
                    onClick={() => props.removeComponent()}
                />

            </div>
        </Fragment>
    )
}

export default ComponentButtons;